function cleanText(value) {
  return String(value || '').replace(/\n/g, '').trim();
}

function safeFilename(name) {
  const base = cleanText(name).replace(/[\\/:*?"<>|]/g, ' ').replace(/\s+/g, ' ').trim();
  return (base || '图表').slice(0, 80);
}

function safeSheetName(name, used) {
  let base = cleanText(name).replace(/[\\/?*[\]:]/g, ' ').trim() || '数据';
  base = base.slice(0, 31);
  let candidate = base;
  let index = 2;
  while (used.has(candidate)) {
    const suffix = ` ${index}`;
    candidate = `${base.slice(0, 31 - suffix.length)}${suffix}`;
    index += 1;
  }
  used.add(candidate);
  return candidate;
}

function toNumber(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'object') {
    if (Object.prototype.hasOwnProperty.call(value, 'value')) return toNumber(value.value);
    return null;
  }
  const number = Number(value);
  return Number.isFinite(number) ? number : value;
}

function formatCell(series, value) {
  const number = toNumber(value);
  if (typeof number !== 'number') return number == null ? '' : number;
  const decimals = series.type === 'line' || (series.yAxisIndex || 0) > 0 ? 2 : 0;
  const factor = 10 ** decimals;
  return Math.round(number * factor) / factor;
}

function seriesColumnName(series, yAxes, multiAxis) {
  const yIndex = series.yAxisIndex || 0;
  const yName = cleanText(yAxes[yIndex] && yAxes[yIndex].name);
  const seriesName = cleanText(series.name);
  if (multiAxis) return yName || seriesName || '数值';
  return seriesName || yName || '数值';
}

function buildSheetsFromOption(option) {
  const series = (option && option.series) || [];
  if (!series.length) return [];

  const xAxis = Array.isArray(option.xAxis) ? option.xAxis[0] : option.xAxis;
  const categories = xAxis && Array.isArray(xAxis.data) ? xAxis.data : null;
  const cartesian = categories
    && categories.length
    && series.some((item) => item.type === 'bar' || item.type === 'line');

  if (cartesian) {
    const yAxes = Array.isArray(option.yAxis) ? option.yAxis : (option.yAxis ? [option.yAxis] : []);
    const multiAxis = series.some((item) => (item.yAxisIndex || 0) > 0);
    const columns = ['类别', ...series.map((item) => seriesColumnName(item, yAxes, multiAxis))];
    const rows = categories.map((category, index) => [
      category,
      ...series.map((item) => formatCell(item, item.data && item.data[index])),
    ]);
    return [{ name: '数据', columns, rows }];
  }

  const used = new Set();
  return series
    .filter((item) => item.type === 'pie' || (Array.isArray(item.data) && item.data.some((point) => point && typeof point === 'object' && point.name != null)))
    .map((item, index) => ({
      name: safeSheetName(item.name || `数据${index + 1}`, used),
      columns: ['名称', '数量'],
      rows: (item.data || [])
        .filter((point) => point && point.name != null && point.name !== '')
        .map((point) => [point.name, formatCell(item, point.value)]),
    }))
    .filter((sheet) => sheet.rows.length);
}

module.exports = {
  buildSheetsFromOption,
  safeFilename,
  safeSheetName,
};
